module.exports = __webpack_public_path__ + "static/firebird.c945ef1a.jpg";